import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  NgZone
} from '@angular/core';

import { GiveFocusMode } from './typings/give-focus.mode';

const DESKTOP_MIN_WIDTH = 1024;
const FOCUSABLE         = [
  'input:not([type="hidden"]):not(:disabled)',
  'select:not(:disabled)',
  'textarea:not(:disabled)',
  '[tabindex]:not([tabindex="-1"])'
].join(', ');

// On a wrapper such as a wor-*-control, the first focusable element inside it takes the focus.
@Directive({
  selector: '[worGiveFocus]'
})
export class GiveFocusDirective implements AfterViewInit {
  @Input() worGiveFocus : GiveFocusMode = '';

  constructor (
    private elementRef : ElementRef<HTMLElement>,
    private ngZone     : NgZone
  ) {}

  ngAfterViewInit () : void {
    if ( this.worGiveFocus === false || ( this.worGiveFocus === 'desktop' && !this.isDesktop() ) ) {
      return;
    }

    this.ngZone.runOutsideAngular(() => setTimeout(() => this.getTarget()?.focus({ preventScroll: true })));
  }

  private getTarget () : HTMLElement | null {
    const host = this.elementRef.nativeElement;

    return host.matches(FOCUSABLE)
      ? host
      : host.querySelector<HTMLElement>(FOCUSABLE);
  }

  private isDesktop () : boolean {
    return document.documentElement.clientWidth > DESKTOP_MIN_WIDTH;
  }
}
